module.exports = __webpack_public_path__ + "static/media/loupsGarous_02_thumb.2caed530.png";